import { gql, useMutation } from '@apollo/client';

type SpecialOrderItemsArgs = {
  productId: number;
  quantity: number;
};

const UPADTE_ORDER = gql`
  mutation UpdateCompanySpecialOrder(
    $specialOrderId: Int!
    $comments: String!
    $specialOrderItems: [SpecialOrderItemsArgs!]!
  ) {
    updateCompanySpecialOrder(
      updateCompanySpecialOrderArgs: {
        specialOrderItems: $specialOrderItems
        comments: $comments
        specialOrderId: $specialOrderId
      }
    ) {
      message
      status
      statusCode
      error
      data {
        specialOrderId
      }
    }
  }
`;

export const useUpdateSpecialOrder = () => {
  const [updateSpecialOrderQuery, { error, data, loading }] =
    useMutation(UPADTE_ORDER);

  const updateSpecialOrder = (
    specialOrderId: number,
    comments: string,
    items: any[],
    onCompleteCb?: (data: any) => any,
  ) => {
    updateSpecialOrderQuery({
      variables: {
        specialOrderId,
        comments,
        specialOrderItems: items,
      },
      onCompleted: onCompleteCb,
    });
  };

  return { updateSpecialOrder, error, data, updateOrderLoading: loading };
};
